export default [
  {
    name: "New Year's Day",
    date: '2024-01-01'
  },
  {
    name: 'Islander Day',
    date: '2024-02-19',
    appliesTo: ['PE']
  },
  {
    name: 'Louis Riel Day',
    date: '2024-02-19',
    appliesTo: ['MB']
  },
  {
    name: 'Nova Scotia Heritage Day',
    date: '2024-02-19',
    appliesTo: ['NS']
  },
  {
    name: 'Family Day',
    date: '2024-02-19',
    appliesTo: ['AB', 'BC', 'NB', 'ON', 'SK']
  },
  {
    name: 'Good Friday',
    date: '2024-03-29',
    doesNotApplyTo: ['QC']
  },
  {
    name: 'Easter Monday',
    date: '2024-04-01',
    appliesTo: ['QC']
  },
  {
    name: 'Victoria Day',
    date: '2024-05-20',
    doesNotApplyTo: ['NB', 'NS', 'NL']
  },
  {
    name: 'National Aboriginal Day',
    date: '2024-06-21',
    appliesTo: ['NT']
  },
  {
    name: 'Discovery Day (NL)',
    date: '2024-06-24',
    appliesTo: ['NL']
  },
  {
    name: 'St. Jean Baptiste Day',
    date: '2024-06-24',
    appliesTo: ['QC']
  },
  {
    name: 'Canada Day',
    date: '2024-07-01'
  },
  {
    name: 'Nunavut Day',
    date: '2024-07-09',
    appliesTo: ['NU']
  },
  {
    name: 'Civic Holiday',
    date: '2024-08-05',
    appliesTo: ['BC', 'SK', 'ON', 'NB', 'NU', 'NT']
  },
  {
    name: 'Alberta Heritage Day',
    date: '2024-08-05',
    appliesTo: ['AB']
  },
  {
    name: 'Discovery Day (YT)',
    date: '2024-08-19',
    appliesTo: ['YT']
  },
  {
    name: 'Labour Day',
    date: '2024-09-02'
  },
  {
    name: 'Thanksgiving',
    date: '2024-10-14',
    doesNotApplyTo: ['NB', 'NS', 'NL']
  },
  {
    name: 'Remembrance Day',
    date: '2024-11-11',
    doesNotApplyTo: ['MB', 'ON', 'QC', 'NS']
  },
  {
    name: 'Christmas Day',
    date: '2024-12-25'
  },
  {
    name: 'Boxing Day',
    date: '2024-12-26',
    appliesTo: ['ON']
  }
];
